module.exports = __webpack_public_path__ + "img/banner2.30074c95.jpg";